import { AvtovazRequisites } from "../api/service";

export const useAvtovazRequisites = () => {
  const getAvtovazRequisiteList = AvtovazRequisites.GET.getList;
  const getAvtovazActiveRequisiteList = AvtovazRequisites.GET.getActiveList;
  const getAvtovazRequisiteBuId = AvtovazRequisites.GET.getById;
  const createAvtovazRequisite = AvtovazRequisites.POST.create;
  const activateAvtovazRequisite = AvtovazRequisites.POST.activate;
  const deactivateAvtovazRequisite = AvtovazRequisites.POST.deactivate;
  const updateAvtovazRequisite = AvtovazRequisites.PUT.update;
  const deleteAvtovazRequisite = AvtovazRequisites.DELETE.delete;
  return {
    getAvtovazRequisiteList,
    getAvtovazActiveRequisiteList,
    getAvtovazRequisiteBuId,
    createAvtovazRequisite,
    activateAvtovazRequisite,
    deactivateAvtovazRequisite,
    updateAvtovazRequisite,
    deleteAvtovazRequisite,
  };
};
